import React from 'react';
import {Link} from 'react-router-dom';

import './SideDrawer.css';

const sideDrawer = props => {
    let drawerClasses = ['side-drawer'];
    if (props.show) {
        drawerClasses = ['side-drawer', 'open'];
    }
    return (
    <nav className={drawerClasses.join(' ')}>
        <ul>
            <li><Link to="/signin">Sign in</Link></li>
            {/* <li><Link to="/about">About</Link></li> */}
            <li><Link to='/contactus'>Contact Us</Link></li>
            <li><Link to='/partner'>Become Our Partner</Link></li>
            {/* <li><Link to='/joininus'>Join in us</Link></li> */}
        </ul>
    </nav>
    );
};

export default sideDrawer;